import { render, staticRenderFns } from "./FlashProducts.vue?vue&type=template&id=5ea18bcd&scoped=true&"
import script from "./FlashProducts.vue?vue&type=script&lang=js&"
export * from "./FlashProducts.vue?vue&type=script&lang=js&"
import style0 from "./FlashProducts.vue?vue&type=style&index=0&id=5ea18bcd&scoped=true&lang=css&"
import style1 from "./FlashProducts.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea18bcd",
  null
  
)

export default component.exports